import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { HoistedQueryProps } from './types';
import { useEventLogQuery } from './use-event-log-query';
import { useEventRelatedDataExistingEventQuery } from './use-event-related-data-existing-event-query';
import { useIntegratedEventDetailsQuery } from '../../common/hooks/use-integrated-event-details-query';
import { useIntegratedEventMergedEventsQuery } from './use-integrated-event-merged-events-query';
import { useAssignedEventDexActivityQuery } from './use-assigned-event-dex-activity-query';

/**
 * In order to properly preserve assigned event information in Assigned Event
 * and Event Details pages when user runs out of internet, we are calling some
 * event queries here to fetch and store their information with React Query's cache.
 *
 * Thus, even if we do not return the values of those queries, they will still be
 * used once we run out of internet and access a page where they are actually applied.
 */
export function useIntegratedAssignedEvent() {
    const unitAssignment = useUnitAssignment();
    const eventId = unitAssignment?.assignedEvent?.eventId;
    const enabled = !!eventId;
    const hoistedQueryProps: HoistedQueryProps = {
        notifyOnChangeProps: [],
        enabled,
    };

    const eventDetailsQuery = useIntegratedEventDetailsQuery({
        eventId,
        enabled,
    });
    useIntegratedEventMergedEventsQuery({
        eventId,
        enabled,
    });
    useEventRelatedDataExistingEventQuery({
        eventId,
        lastUpdatedDateUtc: 'todo',
        hoistedQueryProps,
    });
    useEventLogQuery({
        eventId,
        hoistedQueryProps,
    });
    useAssignedEventDexActivityQuery({
        eventId,
        agencyTypeGlobalAttrId: eventDetailsQuery.data?.agencyTypeGlobalAttrId,
    });
}
